export enum PublicEvents {
	// Generic UI events
	'uxChange',
	'uxClick',
	'uxInput',
	'uxSubmit',
	'uxShow',
	'uxHide',
	'uxResize',
	'uxSyncLabel',

	// Specific component events
	'overlayOpened',
	'overlayClosed',
}

// polyfill for custom events (IE)
(function() {
	if (typeof (window as any)['CustomEvent'] === 'function') {
		return false;
	}
	function CustomEvent(event: string, params: any) {
		params = params || { bubbles: false, cancelable: false, detail: undefined };
		var evt = document.createEvent('CustomEvent');
		evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
		return evt;
	}
	CustomEvent.prototype = (window as any)['Event'].prototype;
	(window as any)['CustomEvent'] = CustomEvent;
})();

/**
 * Triggers a public event for external single page applications
 * @param  {PublicEvents}   type             Event type
 * @param  {TerrificSpec}   terrificModule   Terrific module
 * @param  {Element} target           Target element
 * @param  {Object}         eventData        Event Data Object
 * @return {boolean}        true if event was not rejected
 */
export function triggerPublicEvent(
	type: PublicEvents,
	terrificModule: any,
	target: Element,
	eventData: Object = {}
): boolean {
	const eventName = PublicEvents[type];
	const terrificModuleName = terrificModule ? (terrificModule._ctx.dataset.tName as string) : '';
	const data: object = {
		module: terrificModule,
		name: terrificModuleName,
		eventData: eventData,
	};
	const event = new CustomEvent(`${eventName}`, { detail: data });
	target.dispatchEvent(event);

	return true;
}

/**
 * Bind to a public event and returns an unbind helper
 *
 * @param  {PublicEvents}   type    Event type
 * @param  {Element|JQuery} element Target element
 * @param  {Object} callback
 * @return {Object}  Off-Function to Event
 */
export function onPublicEvent(
	type: PublicEvents,
	element: Element,
	callback: (event: Event, data: object) => void
): () => void {
	const eventName = PublicEvents[type];
	const eventHandler: any = (event: Event) => callback(event as any, (event as any)['detail'] as object);
	element.addEventListener(`${eventName}`, eventHandler);
	return () => element.removeEventListener(`${eventName}`, eventHandler);
}

export default {
	PublicEvents,
	onPublicEvent,
	triggerPublicEvent,
};
